import styled from "styled-components";

const TableWrap = styled.div`
	> table {
		th {
			height: 50px;
			padding: 0 10px;
			text-align: left;
		}
		td {
			height: 50px;
			padding: 0 10px;
			text-align: left;
			vertical-align: top;
			> div {
				padding: 15px 0;
			}
		}
		tr {
			&:first-child {
				td {
					vertical-align: middle;
				}
			}
		}
	}
`;
const ProductExplain = styled.div`
	font-size: 16px;
	color: var(--emp-color);
	vertical-align: top;
`;
const ProductPrice = styled.div`
	width: 100%;
	height: auto;
	font-size: 16px;
	text-align: right;
	vertical-align: middle;
	color: var(--red-color);
	em {
		font-family: "pr-font-medium";
	}
`;

const AirplaneNumber = styled.span`
	font-family: "pr-font-medium";
	color: #3094fb;
`;

const AirplaneDepart = styled.span`
	color: var(--default-color);
`;
const AirplaneDay = styled.span`
	color: var(--emp-color);
`;
const ScheduleTitle = styled.h5`
	position: relative;
	display: flex;
	align-items: center;
	height: 50px;
	padding: 0 10px;
	margin: 0 -10px;
	background: var(--disabled-color);
	border-bottom: 1px solid var(--line-color);
	color: var(--emp-color);
	text-align: left;
	font-size: var(--default-size);
	font-weight: normal;
	word-break: keep-all;
`;
const ScheduleList = styled.ul`
	margin: 14px 0;
`;
const ScheduleListItem = styled.li`
	+ li {
		margin-top: 22px;
	}
`;
const ScheduleSubTitle = styled.p`
	margin-bottom: 3px;
	font-size: 15px;
	color: var(--emp-color);
`;
const ScheduleText = styled.p`
	font-size: 15px;
	color: var(--default-color);
`;
const LocationTitle = styled.h4`
	position: relative;
	padding-left: 40px;
	margin-top: 20px;
	font-size: 20px;
	font-family: "pr-font-medium";
	color: var(--emp-color);

	i {
		position: relative;

		&:before {
			position: absolute;
			z-index: 2;
			top: 1px;
			left: -31px;
			display: block;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			border: 4px solid #3094fb;
			background-color: #fff;
			content: "";
		}

		&:after {
			position: absolute;
			z-index: 2;
			top: 13px;
			left: -30px;
			display: block;
			width: 0;
			height: 10px;
			border-left: 7px solid transparent;
			border-right: 7px solid transparent;
			border-top: 9px solid #3094fb;
			transform-origin: 0 100%;
			content: "";
		}
	}

	span {
		padding-left: 20px;
	}
`;
const LocationText = styled.p`
	position: relative;
	padding-left: 40px;
	margin-top: 15px;

	&:before {
		position: absolute;
		top: 5px;
		left: 9px;
		z-index: 1;
		display: block;
		width: 6px;
		height: 6px;
		border-radius: 50%;
		border: 5px solid #daecfe;
		background-color: #3094fb;
		content: "";
	}
`;
const TourList = styled.ul`
	margin: 14px 0;
`;
const TourListItem = styled.li`
	display: flex;
	justify-content: space-between;
	+ li {
		margin-top: 4px;
	}
`;
const TourName = styled.span`
	flex: 1 1 auto;
`;
const TourPrice = styled.span`
	flex: 0 0 100px;
	text-align: right;
	color: var(--blue-color);
`;
const BtnBlock = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export {
	AirplaneDay,
	AirplaneDepart,
	AirplaneNumber,
	BtnBlock,
	LocationText,
	LocationTitle,
	ProductExplain,
	ProductPrice,
	ScheduleList,
	ScheduleListItem,
	ScheduleText,
	ScheduleTitle,
	TableWrap,
	TourList,
	TourListItem,
	TourName,
	TourPrice,
	ScheduleSubTitle,
};
